<template>
  <div class="slider">
    <div class="bar">
      <yxt-slider
        input-size='mini'
        :value="value"
        @input="handleInput"
        :max="max"
        vertical
        height="97px"
      >
      </yxt-slider>
    </div>
    <div class="text">
      {{value}}%
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    max: [String, Number]
  },
  methods: {
    handleInput(v) {
      this.$emit('input', v);
    }
  }
};
</script>
<style scoped>
.bar ::v-deep .yxt-slider--mini.is-vertical .yxt-slider__runway {
  width: 3px;
  margin: 0 12px;
}
.bar ::v-deep  .yxt-slider--mini .yxt-slider__button {
  width: 9px;
  height: 9px;
}
</style>
<style scoped lang="scss">
.slider {
  position: absolute;
  width: 40px;
  left: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  bottom: 36px;
  background: #ffffff;
  box-shadow: 4px 4px 9px 1px rgba(9, 34, 76, 0.05);
  border-radius: 2px;
  border: 1px solid #e9e9e9;
  padding-top: 24px;
  .text {
    font-size: 12px;
    color: #757575;
    display: inline-block;
    text-align: center;
    padding: 2px 0;
  }
  .bar {
    height: 100%;
    box-sizing: border-box;
    &-outer {
      border-radius: 3px;
      background-color: #f0f0f0;
      height: 100%;
      overflow: hidden;
      position: relative;
    }
    &-inner {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: var(--color-primary);
      text-align: right;
      border-radius: 100px;
      line-height: 1;
      white-space: nowrap;
      transition: width 0.6s ease;
    }
  }
}
</style>
